import React from "react";
import { Box } from "@mui/material";
import RegisterElement from "../Components/LoginComponent/RegisterElement";
import Footer from "../Components/Footer";


const RegisterPage = () => {
    return (
        <Box
        sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#ffffff",
            padding: "24px",
            boxSizing: "border-box",
            overflow: "hidden",
            fontFamily: "'Inter', sans-serif",
          }}
      >
        <RegisterElement /> 
      </Box>
      );
    };
  
  export default RegisterPage;